import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Users, UserCheck } from "lucide-react";
import Default from "../components/profile_admins/default/Default";
import WithRoleRef from "../components/profile_admins/with_role_ref/WithRoleRef";

const ProfileAdmins = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("profile-admin");

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam === "roles") {
      setActiveTab("profile-admins-roles");
    } else {
      setActiveTab("profile-admin");
    }
  }, [searchParams]);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);

    if (tab === "profile-admins-roles") {
      navigate("?tab=roles", { replace: true });
    } else {
      navigate(window.location.pathname, { replace: true });
    }
  };

  return (
    <section className="p-6 bg-gray-50 ">
      {/* Beautiful Tab Navigation */}
      <div className="mb-8">
        <div className="bg-white p-2 rounded-xl shadow-sm border border-gray-200 inline-flex space-x-1">
          <button
            onClick={() => handleTabChange("profile-admin")}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
              activeTab === "profile-admin"
                ? "bg-blue-600 text-white shadow-md transform scale-105"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            <Users size={18} />
            <span>Profile Admin</span>
          </button>
          <button
            onClick={() => handleTabChange("profile-admins-roles")}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
              activeTab === "profile-admins-roles"
                ? "bg-blue-600 text-white shadow-md transform scale-105"
                : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
            }`}
          >
            <UserCheck size={18} />
            <span>Profile Admins with Roles</span>
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
        {activeTab === "profile-admin" && <Default />}

        {activeTab === "profile-admins-roles" && <WithRoleRef />}
      </div>
    </section>
  );
};

export default ProfileAdmins;
